import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-delete',
	path: '/secure/admin/DeleteIssueType!default.jspa',
};
